import React from 'react'
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material'
import {
    SearchVehiclesByAccountDetailComponent,
    SearchByBuyerDetailComponent,
    SearchVehiclesDetailComponent,
    SearchVehiclesWithDealsDetailComponent,
    SearchVehiclesDMSFeedDetailComponent,
} from '../../../feature-views'
import type { DashboardCardDef } from '@edge/spark/io-dashboards'
import { useIsLandscape, useIsMobile } from '@edge/spark/ui-mui'

interface Props {
    widgetDef: DashboardCardDef
    handleClose: () => void
}

export const CardDetailModal: React.FC<Props> = ({ widgetDef, handleClose }: Props) => {
    const mobile = useIsMobile()
    const landscape = useIsLandscape()
    const isMobile = mobile || landscape

    const handleCloseModal = (): void => {
        handleClose()
    }

    const searchView = widgetDef?.config?.search?.searchDetailView
    const searchString = widgetDef?.config?.search?.searchString || ''
    const searchTitle = widgetDef?.config?.search?.searchDetailTitle || ''

    return (
        <Dialog
            open
            onClose={handleCloseModal}
            maxWidth="lg"
            fullWidth
            fullScreen={isMobile}
            sx={{ m: 0, p: 1 }}
            // keep border radius when fullScreen mode is enabled
            PaperProps={{ style: { borderRadius: '4px' } }}
        >
            <DialogContent sx={{ p: { xs: '6px', md: 0 } }}>
                {searchView?.toLowerCase() === 'sellers' && (
                    <SearchVehiclesByAccountDetailComponent searchString={searchString} title={searchTitle} />
                )}
                {searchView?.toLowerCase() === 'buyers' && (
                    <SearchByBuyerDetailComponent searchString={searchString} title={searchTitle} />
                )}
                {searchView?.toLowerCase() === 'vehicles' && (
                    <SearchVehiclesDetailComponent searchString={searchString} title={searchTitle} />
                )}
                {searchView?.toLowerCase() === 'dms vehicles' && (
                    <SearchVehiclesDMSFeedDetailComponent searchString={searchString} title={searchTitle} />
                )}
                {searchView?.toLowerCase() === 'deals' && (
                    <SearchVehiclesWithDealsDetailComponent searchString={searchString} title={searchTitle} />
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={handleClose}
                    color="primary"
                    variant="contained"
                    size={isMobile ? 'large' : 'medium'}
                >
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    )
}
